// extracted by mini-css-extract-plugin
module.exports = {"sidebarPaper":"styles_sidebarPaper__1YHfY","dataItem":"styles_dataItem__1rzms"};